
import Loading from 'vux/src/components/loading/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

import { getInvestorOtherAuth } from 'api/investor'
export default {
components: {
Loading,
Group,
XHeader,
XInput,
Selector,
XNumber,
Datetime,
XButton,
PopupRadio
},
data () {
return {
localValidity: '存在有效期',
loading: true,
type: 0,
data: {
managersName: '',
managersSex: '',
managersAge: '',
managersDocumentsType: '身份证',
managersIdCardNo: '',
managersDocumentsValidity: '',
managersPosition: '',
managersLanline: '',
managersMobile: '',
managersEmail: '',
managersZip: '',
managersAddress: '',
relationshipWithOrg: ''
},
isIdCard: function (value) {
return {
valid: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(value),
msg: '身份证号码格式不正确'
}
},
isPhone: function (value) {
return {
valid: /\d{1,20}/.test(value),
msg: '号码格式不正确'
}
},
valid: {
managersName: false,
managersSex: false,
managersAge: false,
managersDocumentsType: false,
managersIdCardNo: false,
managersDocumentsValidity: false,
managersPosition: false,
managersLanline: false,
managersMobile: false,
managersEmail: false,
managersZip: false,
managersAddress: false,
relationshipWithOrg: false
}
}
},
watch: {
localValidity: function (val, oldVal) {
if (val === '永久有效') {
this.data.managersDocumentsValidity = val
} else {
this.data.managersDocumentsValidity = ''
}
}
},
created () {
this.$vux.loading.show({text: '加载中'})
this.$bridge.registerHandler('getUpdate', this.$_agency_update)
this.$_agency_init()
},
methods: {
$_agency_update () {
this.type = 1
},
$_agency_init () {
let _this = this
setTimeout(() => {
_this.type = parseInt(this.$route.query.type)
if (_this.$route.query.oldInfo) {
let res = JSON.parse(this.$route.query.oldInfo)
_this.data = {
managersName: res.managersName,
managersSex: res.managersSex,
managersAge: res.managersAge,
managersDocumentsType: res.managersDocumentsType,
managersIdCardNo: res.managersIdCardNo,
managersDocumentsValidity: res.managersDocumentsValidity,
managersPosition: res.managersPosition,
managersLanline: res.managersLanline,
managersMobile: res.managersMobile,
managersEmail: res.managersEmail,
managersZip: res.managersZip,
managersAddress: res.managersAddress,
relationshipWithOrg: res.relationshipWithOrg
}
} else if (_this.$route.query.isThree) {
_this.data = {
managersName: _this.$route.query.representativeName,
managersSex: _this.$route.query.representativeSex,
managersAge: _this.$route.query.representativeAge,
managersDocumentsType: _this.$route.query.representativeDocumentsType,
managersIdCardNo: _this.$route.query.representativeIdCardNo,
managersDocumentsValidity: _this.$route.query.representativeDocumentsValidity,
managersPosition: _this.$route.query.representativePosition,
managersLanline: _this.$route.query.representativeLanline,
managersMobile: _this.$route.query.representativeMobile,
managersEmail: _this.$route.query.representativeEmail,
managersZip: _this.$route.query.representativeZip,
managersAddress: _this.$route.query.representativeAddress,
relationshipWithOrg: ''
}
}
_this.loading = false
_this.$vux.loading.hide()
}, 500)
},
idcardChange (val) {
if (this.type === 1) {
if (val && val.length === 18) {
let year = parseInt(val.substring(6, 10))
let Year = new Date().getFullYear()
this.data.managersAge = Year - year
let sex = parseInt(val.substr(16, 1))
this.data.managersSex = sex % 2 === 0 ? '女' : '男'
}
}
},
$_agency_auth () {
if (this.type === 0) {
this.$_agency_next()
} else {
for (var item in this.valid) {
console.log(this.data[item])
if (this.data[item] === '') {
this.$vux.toast.show({type: 'warn', text: this.$refs[item].title + '为空或输入不合规范'})
return
}
}
this.$_handle_auth()
}
},
$_handle_auth () {
this.$vux.loading.show({text: '加载中'})
getInvestorOtherAuth({userId: this.$route.query.userId, invenstemType: this.$route.query.invenstemType, orgName: this.$route.query.orgName, invenstemUserId: this.$route.query.invenstemUserId, name: this.data.managersName, idCard: this.data.managersIdCardNo}, this.$route.query.au).then((res) => {
this.$vux.loading.hide()
if (res.code === 0) {
this.$_agency_next()
} else {
this.$vux.alert.show({
title: '提示',
content: res.msg
})
}
})
},
$_agency_next () {
this.$route.query.type = this.type
this.$router.push({path: '/investor/agency/four', query: Object.assign(this.data, this.$route.query)})
}
}
}



// WEBPACK FOOTER //
// ./src/components/InvestorInfo/Agency/Three.vue